import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import { Input, Select } from '../../components/ui/Input';
import { comissoesApi, funcionariosApi } from '../../api/rh';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';
import ComissoesDetail from './ComissoesDetail';

const MESES = [
  { value: '', label: 'Todos os meses' },
  ...['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    .map((m, i) => ({ value: String(i + 1), label: m }))
];

const ANO_ATUAL = new Date().getFullYear();
const ANOS = Array.from({ length: 5 }, (_, i) => ANO_ATUAL - 3 + i).map(a => ({ value: String(a), label: String(a) }));

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function ComissoesList() {
  useTituloPagina('Comissões');
  const [ano, setAno] = useState(String(ANO_ATUAL));
  const [mes, setMes] = useState('');
  const [funcionarioId, setFuncionarioId] = useState('');
  const [valorMin, setValorMin] = useState('');
  const [valorMax, setValorMax] = useState('');
  const [funcionarios, setFuncionarios] = useState([]);
  const [resumo, setResumo] = useState([]);
  const [aberto, setAberto] = useState(null); // { funcionario_id, funcionario_nome }

  useEffect(() => { funcionariosApi.listarAtivosLista().then(setFuncionarios).catch(() => {}); }, []);

  const carregar = useCallback(() => {
    const params = { ano };
    if (mes) params.mes = mes;
    if (funcionarioId) params.funcionario_id = funcionarioId;
    if (valorMin) params.valor_min = valorMin;
    if (valorMax) params.valor_max = valorMax;
    comissoesApi.resumo(params).then(setResumo).catch(() => {});
  }, [ano, mes, funcionarioId, valorMin, valorMax]);

  useEffect(() => { carregar(); }, [carregar]);

  const opcoesFuncionarios = [{ value: '', label: 'Todos os vendedores' }, ...funcionarios.map(f => ({ value: String(f.id), label: f.nome }))];
  const totalGeral = resumo.reduce((s, r) => s + Number(r.total_comissao), 0);

  if (aberto) {
    return (
      <ComissoesDetail
        funcionarioId={aberto.funcionario_id}
        funcionarioNome={aberto.funcionario_nome}
        ano={ano}
        mes={mes}
        onVoltar={() => setAberto(null)}
      />
    );
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'end' }}>
          <Select label="Ano" options={ANOS} value={ano} onChange={e => setAno(e.target.value)} style={{ width: 110 }} />
          <Select label="Mês" options={MESES} value={mes} onChange={e => setMes(e.target.value)} style={{ width: 170 }} />
          <Select label="Vendedor" options={opcoesFuncionarios} value={funcionarioId} onChange={e => setFuncionarioId(e.target.value)} style={{ width: 220 }} />
          <Input label="Comissão Mínima R$" type="number" step="0.01" value={valorMin} onChange={e => setValorMin(e.target.value)} style={{ width: 150 }} />
          <Input label="Comissão Máxima R$" type="number" step="0.01" value={valorMax} onChange={e => setValorMax(e.target.value)} style={{ width: 150 }} />
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                <th style={{ padding: 10 }}>Vendedor</th>
                <th style={{ padding: 10 }}>Total Vendido</th>
                <th style={{ padding: 10 }}>Total Comissão</th>
              </tr>
            </thead>
            <tbody>
              {resumo.map(r => (
                <tr key={r.funcionario_id} onClick={() => setAberto({ funcionario_id: r.funcionario_id, funcionario_nome: r.funcionario_nome })}
                  style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                  <td style={{ padding: 10 }}>{r.funcionario_nome}</td>
                  <td style={{ padding: 10 }}>{formatarReais(r.total_vendido)}</td>
                  <td style={{ padding: 10, fontWeight: 700, color: COLORS.primary }}>{formatarReais(r.total_comissao)}</td>
                </tr>
              ))}
              {resumo.length === 0 && (
                <tr><td colSpan={3} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma comissão no período filtrado.</td></tr>
              )}
            </tbody>
            {resumo.length > 0 && (
              <tfoot>
                <tr style={{ background: COLORS.primaryBg }}>
                  <td colSpan={2} style={{ padding: 10, textAlign: 'right', fontWeight: 700, color: COLORS.primary }}>Total</td>
                  <td style={{ padding: 10, fontWeight: 700, color: COLORS.primary }}>{formatarReais(totalGeral)}</td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </Card>
    </div>
  );
}
